import http from '@/services/api/http';

export default {
  getForumUrl() {
    return http.get('api/About/ForumURL');
  },
  getTicketsTypes() {
    return http.get('api/Support/Tickets/Types');
  },
  postTicket(payload) {
    const options = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    return http.post('api/Support/Ticket', payload, options);
  },
  getReportUser() {
    return http.get('api/Support/ReportUser');
  },
  postReportUser(payload) {
    return http.post('api/Support/ReportUser', payload);
  },
  getAnnouncements() {
    return http.get('api/About/Announcements');
  },
};



// WEBPACK FOOTER //
// ./src/services/api/support.js